<template>
  <main id="main-content" class="page page--files">
    <div class="page__content">
      <Heading title="All Files" hasDivider="true" />

      <p class="page__intro">All files sent by Nicola Bolton.</p>

      <div class="file-list">
        <File
          heading="Portfolio"
          url="https://www.nicolabolton.co"
          target="_blank"
          :icon="['fas', 'link']"
        />
        <File
          heading="PDF Resume"
          url="https://nicolabolton.co/files/docs/NicolaBolton_Resume.pdf"
          target="_blank"
          :icon="['fas', 'file-pdf']"
        />
        <File
          heading="Github"
          url="https://github.com/nbolton00"
          target="_blank"
          :icon="['fab', 'github']"
        />
        <File
          heading="LinkedIn"
          url="https://www.linkedin.com/in/nicolaerinbolton"
          target="_blank"
          :icon="['fab', 'linkedin']"
        />
        <File
          heading="Dribbble"
          url="https://dribbble.com/nicolabolton"
          target="_blank"
          :icon="['fab', 'dribbble']"
        />
        <File
          heading="Behance"
          url="https://www.behance.net/nicolaebol0e0b"
          target="_blank"
          :icon="['fab', 'behance']"
        />
      </div>
    </div>
  </main>
</template>
<script>
import Heading from "@/components/Heading";
import File from "@/components/File";
export default {
  name: "Files",
  metaInfo: {
    title: "All Files",
    titleTemplate: "%s | HEY"
  },
  components: {
    Heading,
    File
  }
};
</script>
